import actions from './actions'

const STORED_ORDER_KEY = 'STORED_ORDER'

const middleware = () => next => action => {
  switch (action.type) {
    case actions.keycloak.realm.set.toString():
      window.localStorage.setItem('realm', action.payload)
      break
    case actions.keycloak.realm.clear.toString():
      window.localStorage.removeItem('realm')
      break
    case actions.storedOrder.set.toString():
      window.localStorage.setItem(STORED_ORDER_KEY, JSON.stringify(action.payload))
      break
    case actions.storedOrder.get.toString():
      action.payload = {
        ...action.payload,
        value: window.localStorage.getItem(STORED_ORDER_KEY)
      }
      break
    case actions.storedOrder.delete.toString():
      window.localStorage.removeItem(STORED_ORDER_KEY)
      break
  }

  return next(action)
}

export default middleware
